import React from 'react';
import { useCompany } from './CompanyContext';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';

const CompanySelector: React.FC = () => {
  const { selectedCompany, companies, setSelectedCompany, loading } = useCompany();

  // Ensure companies is always an array
  const companiesArray = Array.isArray(companies) ? companies : [];

  if (loading) {
    return (
      <div className="flex items-center justify-center p-4">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (companiesArray.length === 0) {
    return (
      <div className="text-center p-6">
        <BuildingOfficeIcon className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">No companies available</h3>
        <p className="mt-1 text-sm text-gray-500">Please contact your administrator to add companies.</p>
      </div>
    );
  }

  // If there's only one company, just show the company info without selector
  if (companiesArray.length === 1) {
    const company = companiesArray[0];
    return (
      <div className="bg-white border border-gray-200 rounded-lg px-4 py-3">
        <div className="flex items-center">
          <BuildingOfficeIcon className="h-5 w-5 text-primary-600 mr-3" />
          <div>
            <p className="text-sm font-medium text-gray-900">{company.name}</p>
            {company.city && company.state && (
              <p className="text-xs text-gray-500">{company.city}, {company.state}</p>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      <select
        value={selectedCompany?.id || ''}
        onChange={(e) => {
          const company = companiesArray.find(c => c.id === e.target.value);
          setSelectedCompany(company || null);
        }}
        className="appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2 pr-10 text-sm font-medium text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 hover:border-gray-400 transition-colors duration-200"
      >
        {companiesArray.map((company) => (
          <option key={company.id} value={company.id}>
            {company.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CompanySelector;
